import { toast } from "react-toastify";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FullScreenLoader, PageTitle } from "components";
import { usePostPointOfSaleMutation } from "redux/api/pointOfSaleApi";
import { useGetAllCompaniesQuery } from "redux/api/companyApi";
import { PointOfSale } from "components/PointOfSale";
import { ISelectOption } from "Interfaces/Utils";
import { ICompany } from "Models/Company";
import { useGetAllProvincesQuery } from "redux/api/provinceApi";
import { useIntl } from "react-intl";

// Static vars

const RETURN_PAGE = "/point-of-sale";

/**
 * Component to render news creation view
*/

export const PointOfSaleNewPage = () => {
    const { formatMessage } = useIntl();
  
  const PAGE_TITLE = formatMessage({ id: "pointOfSale.createTitle" });
  const RETURN_LABEL = formatMessage({ id: "pointOfSale.back" });
  const UPDATE_SUCCESS_LABEL = formatMessage({ id: "pointOfSale.createdSuccessfuly" });
  const navigate = useNavigate();

  // API calls

  const [ createPointOfSale, { data: postedPointOfSaleData, isSuccess: isPostedPointOfSaleSuccess, error: apiError } ] = usePostPointOfSaleMutation();
  const { data: companies, isLoading: isCompaniesLoading } = useGetAllCompaniesQuery();
  const {data: provinces, isLoading: isProvincesLoading} = useGetAllProvincesQuery();


  // UseEffect to manage creation success

  useEffect(() => {
    if (isPostedPointOfSaleSuccess && postedPointOfSaleData) {
      toast.success(UPDATE_SUCCESS_LABEL);
      navigate(RETURN_PAGE);
    }
  }, [isPostedPointOfSaleSuccess, postedPointOfSaleData, navigate]);

  // Function to create news with form results

  const postPointOfSaleHandler = (formData: FormData) => {
    createPointOfSale(formData);
  };
  const groupSelectOptions: ISelectOption[] = useMemo(() => {

    if (!companies) return [];

    return companies.map((company: ICompany) => ({
      label: company.name,
      value: company._id,
    }));
    
  }, [companies])

  const provinceSelectOptions: ISelectOption[] = useMemo(() => {
      
    if (!provinces) return [];    
     return provinces.map((province) => ({
      label: province.name,
      value: province._id,
    }));
  }, [provinces])

  if (isCompaniesLoading||isProvincesLoading) return <FullScreenLoader/>

  return (
    <>
      <PageTitle
        pageTitle={PAGE_TITLE}
        returnPage={RETURN_PAGE}
        returnLabel={RETURN_LABEL}
      />
      <PointOfSale.Form
        onSubmit={postPointOfSaleHandler}
        companies={groupSelectOptions}
        provinces={provinceSelectOptions}
        apiError={apiError}
      />
    </>
  );
};